export const releaseDetail = {
    version: '4.3.0',
    date: '19/03/2025',
}